module.exports = __webpack_public_path__ + "img/entrance_introduction.03f5e872.svg";